module.exports = __webpack_public_path__ + "static/media/ftue-1-rm-icon.37fa6042.svg";